// extracted by mini-css-extract-plugin
export default {"sidebar":"MenuPropertiesGroups_sidebar__RhBT4","groupsBox":"MenuPropertiesGroups_groupsBox__adWb1","groupsBox_close":"MenuPropertiesGroups_groupsBox_close__HtHWQ"};